import React, { useEffect, useState, useCallback } from "react";
import { DatePicker, Button, Space, Toast } from "antd-mobile";
import moment from "moment";
import "./style.css";

const RenderDatePicker = ({
  visible = false,
  min = undefined,
  max = undefined,
  outputFormat = null,
  close = () => null,
  onConfirm = () => null,
  value
}) => {
  const now = new Date(value?.replace(/(\d+[/])(\d+[/])/, "$2$1") || '');

  const labelRenderer = useCallback((type, data) => {
    switch (type) {
      case "month":
        return "tháng " + data;
      default:
        return data;
    }
  }, []);

  return (
    <Space align="center">
      <DatePicker
        className="datePicker-overide"
        min={min}
        max={max}
        visible={visible}
        cancelText="Quay lại"
        confirmText="Chọn"
        renderLabel={labelRenderer}
        onClose={() => close()}
        onConfirm={(value) => {
          onConfirm(moment(value).format(outputFormat || "DD/MM/YYYY"));
        }}
        defaultValue={now}
      ></DatePicker>
    </Space>
  );
};

export default RenderDatePicker;
